import { PwaPushNotificationsUserSettings } from '../../services/pwa-push-notification/pwa-push-notifications-user-settings.type';
import { LoadStatus } from '../load-status';

/**
 * Feature key under which the PWA push-notification slice is registered in the root store.
 */
export const PWA_PUSH_NOTIFICATION_FEATURE_KEY = 'pwaPushNotification';

/**
 * Live, browser-reported health of the push subscription, reconciled against `PushManager` on
 * app init, visibility resume, and browser-initiated subscription changes. Never persisted —
 * `Unchecked` at the start of every session until the first reconciliation completes.
 */
export enum PushSubscriptionHealth {
    Unchecked = 'unchecked',
    Subscribed = 'subscribed',
    Renewing = 'renewing',
    NotSubscribed = 'not-subscribed',
}

/**
 * The user's push-notification subscription choice, mirroring what
 * `PwaPushNotificationsLocalStorageService` persists in `localStorage`. `undefined` settings
 * means nothing has been saved yet (a first-time user). `status` tracks whether the settings
 * have been read from storage (see {@link LoadStatus}). `subscriptionHealth` is live, derived
 * state — see {@link PushSubscriptionHealth}.
 */
export type PwaPushNotificationState = Readonly<{
    settings: PwaPushNotificationsUserSettings | undefined;
    status: LoadStatus;
    subscriptionHealth: PushSubscriptionHealth;
}>;

export const initialPwaPushNotificationState: PwaPushNotificationState = {
    settings: undefined,
    status: LoadStatus.Idle,
    subscriptionHealth: PushSubscriptionHealth.Unchecked,
};
